import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RtUnitTrainDetailsComponent } from './rt-unit-train-details/rt-unit-train-details.component';
import { RtUnitTrainSummaryGridService } from './rt-unit-train-summary-grid.service';
import { MatCardModule } from '@angular/material/card';
import { MatToolbarModule } from '@angular/material/toolbar';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatButtonModule } from '@angular/material/button';
import { RailtracTripModule } from '@bds/railtrac';

@NgModule({
    declarations: [RtUnitTrainDetailsComponent],
    imports: [
        CommonModule,
        MatCardModule,
        MatToolbarModule,
        MatButtonModule,
        FontAwesomeModule,
        RailtracTripModule,
    ],
    exports: [RtUnitTrainDetailsComponent],
    providers: [RtUnitTrainSummaryGridService],
})
export class RtUnitTrainSummaryModule {}
